import { UserOrderRatesService } from '@/backend/market'
import type { OrderRateFilterEntity } from '../../domain/entities/OrderRateFilterEntity'
import { OrderRateRepository } from '../../domain/repositories/OrderRateRepository'
import { OrderRateFilterModel } from '../models/OrderRateFilterModel'
import type { OrderRateMiniEntity } from '../../domain/entities/OrderRateMiniEntity'
import { OrderRateMiniModel } from '../models/OrderRateMiniModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'

export class OrderRateRepositoryImpl implements OrderRateRepository {
  async getOrderRate(
    filterData: OrderRateFilterEntity
  ): Promise<PaginateEntity<OrderRateMiniModel[]> | { error: true }> {
    const orderRateFilterModel = new OrderRateFilterModel(filterData)
    try {
      const response = await UserOrderRatesService.getUserOrderRatesAdmin(orderRateFilterModel)
      const orderRateResponseModel = response.items?.map((item) => new OrderRateMiniModel(item))
      const result = new PaginateEntity<OrderRateMiniModel[]>(response, orderRateResponseModel)
      return result
    } catch {
      return { error: true }
    }
  }
  async getOrderRateByOrderId(orderId: string): Promise<OrderRateMiniEntity | { error: true }> {
    const orderRateFilterModel = new OrderRateFilterModel({
      orderId: orderId
    })
    try {
      const response = await UserOrderRatesService.getUserOrderRatesAdmin(orderRateFilterModel)
      const orderRateMiniModel = new OrderRateMiniModel(response.items ? response.items[0] : {})

      return orderRateMiniModel
    } catch {
      return { error: true }
    }
  }

  async approveOrderRate(orderRateId: string): Promise<{ error: boolean }> {
    try {
      await UserOrderRatesService.approveUserOrderRateAdmin({ userOrderRateId: orderRateId })
      return { error: false }
    } catch {
      return { error: true }
    }
  }
  
  async hideOutComment(orderRateId: string): Promise<{ error: boolean }> {
    try {
      await UserOrderRatesService.hideOutCommentAdmin({ userOrderRateId: orderRateId })
      return { error: false }
    } catch {
      return { error: true }
    }
  }
}
